<template>
  <div id="app" ref="app" class="app" @DOMMouseScroll="scrollInit" @mousewheel="scrollInit">
  <!-- <div id="app" ref="app" class="app"> -->
    <!-- <headTop :data="'yes'"></headTop> -->
    <div :class="{'header':true,'header-60':$route.name==='partyLanguage'}" v-if="$route.name!=='qa'&&!strArr.includes($route.name)">
      <headTop :data="'yes'" :imgShow="true"></headTop>
      <search @updateResult="updateResult" v-if="$route.name!=='partyLanguage'"></search>
    </div>
    <Nav ref="nav" :showFixedNav="showFixedNav" v-if="$route.name!=='partyLanguage'&&$route.name!=='qa'&&!strArr.includes($route.name)"></Nav>
    <router-view v-if="$route.name==='result' || $route.name==='result1'" ref="result"/>
    <router-view v-else />
    <foot v-if="$route.name!=='qa'&&!strArr.includes($route.name)"></foot>
  </div>
</template>

<script>
import Nav from "./components/nav.vue";
import search from './components/search.vue';
export default {
  data(){
    return{
      showFixedNav:false,
      strArr:['app','appIframe','xjp']
    }
  },
  components: {
    Nav,
    search
  },
  methods:{
    scrollInit(){
      if(this.$route.name==='qa') return
      let scrollTop = document.getElementById('app').scrollTop
      this.showFixedNav = this.$refs.nav.$el.offsetTop < scrollTop
    },
    updateResult(){
      this.$refs.result.changePage(1)
    }
  }
}
</script>

<style lang="scss">
.app{
  height: 100vh;
  overflow-x: hidden;
}

/* 检索页、检索结果页共用的顶部 */
.result-box {
  .personal{
    padding-top: 15px;
    .txt-login .username{
      color:$erHeadColor;
    }
  }
  .logo{
    span{
      font-size: 18px;
    }
  }
}
.result-wrap {
  background: $erBodyBg;
  min-height: calc(100vh);
  position: relative;
  .result-box {
    padding-bottom: 112px; //底部的高度加30
  }
  .head-wrap {
    height: 60px;
    background: $erHeadBg;
    .head {
      .logo {
        padding-top: 6px;
        padding-left: 35px;
        color: #fff;
        font-size: 14px;
        line-height: 19px;
        .p1 {
          font-size: 30px;
          line-height: 40px;
        }
      }
    }
  }
  .crumb {
    height: 60px;
    .el-breadcrumb {
      padding-left: 35px;
      line-height: 60px;
      color: #3c424a;
    }
  }
  .result {
    border-radius: 20px;
    border: solid 1px #bdbdbd;
    background: #fff;
  }
}
// 面包屑
.crumb{
  .el-breadcrumb__inner a:hover, .el-breadcrumb__inner.is-link:hover{
    color:$loginBtn;
  }
}
/* 检索页、检索结果页共用的底部样式 */
.footer-wrap-i {
  height: 82px;
  min-width: 1200px;
  position: absolute;
  left: 0;
  bottom: 0;
  background:$erFootBg;
  .footer-i{
    p{
      color:#fff;
    }
  }
}
.footer-i p {
  line-height: 60px;
  font-size: $footSize;
  color: $footColor;
  text-align: center;
  span {
    width: 67px;
    display: inline-block;
  }
}
// 提示框样式调整！！
.el-message{
    padding: 20px 15px 20px 20px !important;
    top:30px !important;
    font-size: 20px !important;
    color:#fff !important;
}
.el-message--success{
  background:#44921e !important;
  border-color:#44921e !important;
}
.el-message .el-icon-success,.el-message--success .el-message__content{color:#fff !important;}
.el-message__icon,.el-message__content{font-size: 20px !important;}
//confirm弹窗 warning样式
.el-message-box__status.el-icon-warning {
    color: #d33f3f!important;
}
// 综合数据分析按钮+课题招标+课题推荐+课题结题
.analyze-more {
		// position: absolute;
		// right: 3%;
		// top: 25px;
		font-size: 14px;
		background: $analyzeMoreBg;
		height: 32px;
		line-height: 30px;
		text-align: center;
		padding: 0 10px;
		border-radius: 5px;
		color: #fff;
		cursor: pointer;
    z-index: 10;
    margin-right: 10px;
  }
  .analyze-more-project{
    background:none;
    color:#6e8eb9;
    margin-right: 0;
    &:hover{
      color:#f70;
    }
  }
  //loading的颜色
  .el-loading-spinner{
    .path{
      stroke:$loadingColor!important;
    }
    .el-loading-text{
      color:$loadingColor!important;
    }
  }

// 分页-背景色
  .el-pagination.is-background .el-pager li:not(.disabled){
    &:hover{
      color: $pageBg;
    }
    &.active{
      background:$pageBg;
      color: #fff !important;
    }
  }
  .el-pagination.is-background{
    .el-pager li,.btn-next,.btn-prev,span:not([class*=suffix]){
      height: 36px;
      line-height: 36px;
      min-width: 35px;
      border-radius: 0;
      background-color: transparent;
    }
    .el-pager li,.btn-next,.btn-prev{
      border: 1px solid #EFEFEF;
    }
  .el-pager {
    li{
    padding: 0 14px;
      &.active{
      color:$pageBg!important;
    }
    }
  }
  }
//免责声明样式
.statementCon{
  padding-bottom: 15px;
  .el-message-box__title{
    text-align:center;
    font-weight: bold;
    padding-top: 4px;
  }
  .el-message-box__status{
    top:30%;
  }
  .el-message-box__content{
    padding:10px 20px 17px 20px;
    font-size: 15px;
  }
  .el-message-box__btns{
    text-align:center;
  }
  .el-message-box__message{
      text-align:center;
  }
  .warn{
      color:#d33f3f;
      text-align:right;
      font-size: 14px;
      line-height: 30px;
      span{
          vertical-align:middle;
          font-size: 16px;
          margin-right: 5px;
      }
  }
}
//tooltip设置最大宽度
.el-tooltip__popper{
  max-width: 400px!important;
  line-height: 1.5!important;
  font-size: 14px!important;
}
</style>
